module.exports = "/_next/static/images/edit-54cd226c8831e64cf71d29d8ca96b3b8.svg";